// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"160":"ec87e327","183":"b075fdb8"}[chunkId] + ".js";
};